/** Normalize API row (MySQL may return varying column casing). */
export function normalizeOpdTemplate(row, index = 0) {
  if (!row || typeof row !== 'object') return null;
  const id =
    row.OpdFormTemplateId ??
    row.opdformtemplateid ??
    row.OPDFORMTEMPLATEID ??
    index;
  return {
    ...row,
    OpdFormTemplateId: id,
    TemplateKey: row.TemplateKey ?? row.templatekey ?? `template-${index}`,
    TemplateName: row.TemplateName ?? row.templatename ?? 'Form template',
    AgeMinMonths: row.AgeMinMonths ?? row.ageminmonths ?? 0,
    AgeMaxMonths: row.AgeMaxMonths ?? row.agemaxmonths ?? 0,
    IsRecommended: row.IsRecommended ?? row.isrecommended ?? 0,
    SchemaJson: row.SchemaJson ?? row.schemajson ?? row.SchemaJSON,
  };
}

export function parseSchema(schema) {
  if (!schema) return { sections: [] };
  if (typeof schema === 'string') {
    try {
      return JSON.parse(schema);
    } catch {
      return { sections: [] };
    }
  }
  return schema;
}

export function computeAgeMonths(years, months) {
  const y = Number(years);
  const m = Number(months);
  const ySafe = Number.isFinite(y) && y >= 0 ? y : 0;
  const mSafe = Number.isFinite(m) && m >= 0 ? m : 0;
  return ySafe * 12 + mSafe;
}

export function validateBeforeSubmit(schema, formData, patient) {
  const errors = [];
  const name = (patient.patientName || '').trim();
  const email = (patient.patientEmail || '').trim();
  if (!name) errors.push('Patient name is required.');
  if (!email) errors.push('Patient email is required.');
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.push('Enter a valid patient email.');
  if (!patient.templateId) errors.push('Select a form template.');

  (schema?.sections || []).forEach((section) => {
    (section.fields || []).forEach((field) => {
      if (!field.required) return;
      const val = formData[field.id];
      if (field.type === 'checkboxGroup') {
        if (!Array.isArray(val) || !val.length) errors.push(`${field.label} is required.`);
      } else if (field.type === 'checkbox') {
        if (!val) errors.push(`${field.label} is required.`);
      } else if (val == null || String(val).trim() === '') {
        errors.push(`${field.label} is required.`);
      }
    });
  });

  return errors;
}

export function pickRecommendedTemplate(templates) {
  if (!templates?.length) return null;
  const recommended = templates.find(
    (t) => Number(t.IsRecommended) === 1 || t.IsRecommended === true
  );
  return recommended || templates[0];
}

export function todayIsoDate() {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
}

export function currentTimeHHMM() {
  const d = new Date();
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}
